import { formatDate } from "../services/receipt.service";
import {
    COLORS, buildDocDefinition, openPdf, headerRowOf, zebraRow, totalRow, emptyRow,
    fmtLongDate, fmtAmount, fmtINR, sumBy,
} from "./reportTheme";

// SN | Receipt No | Receipt Date | Seva 1 | Date 1 | Seva 2 | Date 2 | Persons | Amount
const WIDTHS = [20, 48, 48, "*", 48, 55, 48, 34, 52];
const COLS = WIDTHS.length;

export const PeriodicReportPrint = async (fromDate, toDate, logoBase64, periodicList = []) => {
    const grandTotal = sumBy(periodicList, "totalAmount");
    const totalPersons = sumBy(periodicList, "totalPerson");

    const body = [
        headerRowOf([
            ["SN", "center"], ["Receipt No"], ["Receipt Date"], ["Seva 1"], ["Date 1"],
            ["Seva 2"], ["Date 2"], ["Persons", "right"], ["Amount (₹)", "right"],
        ]),
        ...periodicList.map((item, i) =>
            zebraRow([
                { text: i + 1, alignment: "center", color: COLORS.muted },
                { text: item.receiptNo || "-", bold: true },
                { text: formatDate(item.receiptDate) || "-" },
                { text: item.poojaName || "-" },
                { text: formatDate(item.poojaDateTime1) || "-" },
                { text: item.poojaName2 || "-" },
                { text: formatDate(item.poojaDateTime2) || "-" },
                { text: item.totalPerson || "-", alignment: "right" },
                { text: fmtAmount(item.totalAmount), alignment: "right" },
            ], i)
        ),
        periodicList.length
            ? totalRow("Grand Total", fmtINR(grandTotal), { grand: true, cols: COLS, extra: totalPersons })
            : emptyRow("No records found", COLS),
    ];

    return openPdf(
        buildDocDefinition({
            logoBase64,
            title: "Periodic Seva List",
            summary: [
                { label: "Period", value: `${fmtLongDate(fromDate)} – ${fmtLongDate(toDate)}` },
                { label: "Total Receipts", value: periodicList.length },
                { label: "Total Collection", value: fmtINR(grandTotal), accent: true },
            ],
            body,
            widths: WIDTHS,
            cellPadding: 4,
        })
    );
};

export default PeriodicReportPrint;